import { SplashScreen, TalentechSvgImages } from "@talentech/components";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();

  return (
    <SplashScreen
      image={TalentechSvgImages.NOTIFICATIONS_INFORMATION}
      productName={process.env.REACT_APP_ID || t("Home.ProductName")}
      title={t("Home.InvalidLink.Title")}
      subtitle={
        t("Home.InvalidLink.Subtitle")
      }
      isFullPage={false}
    />
  );
};

export default Home;
